import React, { useState, useEffect } from 'react';
import { Box, Typography, TextField, Button, Paper, Grid } from '@mui/material';
import { getApiUrl } from '../config';
import toast from 'react-hot-toast';

function Contact() {
  const [formData, setFormData] = useState({
    address: '',
    phone: '',
    email: '',
    meta_title: '',
    meta_description: '',
    meta_keywords: '',
    map_embed: ''
  });

  useEffect(() => {
    fetch(getApiUrl('/api/info/contact'), {
      headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') }
    })
    .then(res => res.json())
    .then(data => {
      if (data && data.id) {
        setFormData(data);
      }
    })
    .catch(error => {
      console.error('Error fetching contact info:', error);
      toast.error('خطا در دریافت اطلاعات تماس');
    });
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    try {
      const res = await fetch(getApiUrl('/api/info/contact'), {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + localStorage.getItem('token')
        },
        body: JSON.stringify(formData)
      });

      if (res.ok) {
        toast.success('اطلاعات تماس با موفقیت ذخیره شد');
      } else {
        toast.error('خطا در ذخیره اطلاعات تماس');
      }
    } catch (error) {
      console.error('Error saving contact info:', error);
      toast.error('خطا در ذخیره اطلاعات تماس');
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <Box sx={{ p: 3, fontFamily: 'Vazir' }}>
      <Typography variant="h4" gutterBottom sx={{ fontFamily: 'Vazir', fontWeight: 'bold' }}>
        مدیریت اطلاعات تماس
      </Typography>

      <form onSubmit={handleSubmit}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <Paper sx={{ p: 3, fontFamily: 'Vazir' }}>
              <Typography variant="h6" sx={{ fontFamily: 'Vazir', fontWeight: 'bold', mb: 2 }}>
                اطلاعات تماس
              </Typography>
              <TextField
                fullWidth
                label="آدرس"
                name="address"
                value={formData.address}
                onChange={handleChange}
                margin="normal"
                multiline
                rows={3}
                sx={{ fontFamily: 'Vazir' }}
                inputProps={{ style: { fontFamily: 'Vazir' } }}
              />
              <TextField
                fullWidth
                label="شماره تلفن"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                margin="normal"
                sx={{ fontFamily: 'Vazir' }}
                inputProps={{ style: { fontFamily: 'Vazir' } }}
              />
              <TextField
                fullWidth
                label="ایمیل"
                name="email"
                type="email"
                value={formData.email}
                onChange={handleChange}
                margin="normal"
                sx={{ fontFamily: 'Vazir' }}
                inputProps={{ style: { fontFamily: 'Vazir' } }}
              />
            </Paper>
          </Grid>

          <Grid item xs={12} md={6}>
            <Paper sx={{ p: 3, fontFamily: 'Vazir' }}>
              <Typography variant="h6" sx={{ fontFamily: 'Vazir', fontWeight: 'bold', mb: 2 }}>
                تنظیمات SEO
              </Typography>
              <TextField
                fullWidth
                label="عنوان SEO"
                name="meta_title"
                value={formData.meta_title}
                onChange={handleChange}
                margin="normal"
                sx={{ fontFamily: 'Vazir' }}
                inputProps={{ style: { fontFamily: 'Vazir' } }}
              />
              <TextField
                fullWidth
                label="توضیحات SEO"
                name="meta_description"
                value={formData.meta_description}
                onChange={handleChange}
                margin="normal"
                multiline
                rows={3}
                sx={{ fontFamily: 'Vazir' }}
                inputProps={{ style: { fontFamily: 'Vazir' } }}
              />
              <TextField
                fullWidth
                label="کلمات کلیدی SEO"
                name="meta_keywords"
                value={formData.meta_keywords}
                onChange={handleChange}
                margin="normal"
                sx={{ fontFamily: 'Vazir' }}
                inputProps={{ style: { fontFamily: 'Vazir' } }}
              />
            </Paper>
          </Grid>
        </Grid>

        <Paper sx={{ p: 3, mt: 3, fontFamily: 'Vazir' }}>
          <Typography variant="h6" sx={{ fontFamily: 'Vazir', fontWeight: 'bold', mb: 2 }}>
            نقشه گوگل
          </Typography>
          <TextField
            fullWidth
            label="کد نقشه گوگل (iframe)"
            name="map_embed"
            value={formData.map_embed}
            onChange={handleChange}
            margin="normal"
            multiline
            rows={6}
            sx={{ fontFamily: 'Vazir' }}
            inputProps={{ style: { fontFamily: 'Vazir' } }}
          />
        </Paper>

        <Box sx={{ mt: 3, textAlign: 'center' }}>
          <Button
            type="submit"
            variant="contained"
            size="large"
            sx={{ fontFamily: 'Vazir', fontWeight: 'bold', px: 4, py: 1.5 }}
          >
            ذخیره تمام اطلاعات
          </Button>
        </Box>
      </form>
    </Box>
  );
}

export default Contact; 